import { format } from "date-fns";

/**
 * Transforms timestamp or date into a readable format
 * @param timestamp number or string
 * @returns string - example: Feb 28th, 2023 at 3:18 pm
 */
export const getReadableDateTimeString = (value: number | string): string => {
  const datetime =
    typeof value === "string" ? new Date(value).getTime() : value;

  const date = format(datetime, "MMM do, y");
  const time = format(datetime, "h:mm aaa");

  return `${date} at ${time}`;
};
